import React from 'react';
import { Box } from '@chakra-ui/react';
// Import Swiper React components
import { Swiper } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '../../styles/slider.css';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';

const Slideshow = ({
  children,
  spaceBetween = 20,
  useExternalBreakpoints = false,
  centeredSlides = false,
  slidesPerView = `auto`,
  slidesPerViewDesktop = `auto`,
  navProps = null,
  showPagination = true,
  sliderStyles = {},
  onSlideChange = () => {},
  ...props
}) => {
  const breakpoints = useExternalBreakpoints
    ? {}
    : {
        768: {
          slidesPerView: slidesPerViewDesktop
        }
      };

  return (
    <Box {...props}>
      <Swiper
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween}
        centeredSlides={centeredSlides}
        navigation={navProps === null ? true : navProps}
        pagination={
          showPagination
            ? {
                clickable: true,
                renderBullet: function (index, className) {
                  return `<span class="${className}" key="${index}" aria-label="go to slide ${
                    index + 1
                  }" aria-current="${
                    className.includes('swiper-pagination-bullet-active')
                      ? 'true'
                      : 'false'
                  }" role="button" tabindex="0"></span>`;
                }
              }
            : false
        }
        modules={[Pagination, Navigation]}
        breakpoints={breakpoints}
        style={sliderStyles}
        onSlideChange={onSlideChange}
        aria-label="polite">
        {children}
      </Swiper>
    </Box>
  );
};

export default Slideshow;
